#import "./StaffTrainingPolicyFields.graphql"
#import "./StaffTrainingCourseSummaryFields.graphql"

fragment StaffTrainingModuleFields on StaffTrainingModule {
  id
  slug
  title
  controlReference
  durationLabel
  hasVideo
  hasQuiz
  locked
  posterUrl
  status
  dueOn
  daysLeft
  bestScore
  passedAt
  expiresOn
  summary
  body
  keyPoints
  links {
    id
    label
    url
    kind
  }
  policies {
    ...StaffTrainingPolicyFields
  }
  videoUrl
  captionsUrl
  captionsVtt
  minWatchPercent
  maxWatchPercent
  videoCompleted
  course {
    ...StaffTrainingCourseSummaryFields
  }
  nextInCourseSlug
  canComplete
  completeBlockedReason
  quiz {
    questionsPerAttempt
    passMark
    canStart
    blockedReason
    openAttemptId
  }
}
